<app-loader [Parent]="this"></app-loader>
@if (Model != null) {
  <div>
    <app-pageheader [Parent]="this">
      <form-edit-button>Edit</form-edit-button>
      <app-form-delete-button [Model]="Model" [Parent]="this" DeleteUrl="integrations/datafeeds/"
        [DeleteCheck]="false"
        DeleteNavLink="/integrations/datafeeds">
      </app-form-delete-button>
    </app-pageheader>
    <div class="columns">
      <div class="column is-6">
        <article class="panel">
          <p class="panel-heading">
            {{Model.Description || 'Data Feed'}}
          </p>
          <a class="panel-block">
            <span class="label">Feed Target</span>
            <span class="value">{{getFeedTargetText(Model.DataFeedTarget)}}</span>
          </a>
          <a class="panel-block">
            <span class="label">Feed Type</span>
            <span class="value">{{getFeedTypeText(Model.FeedType)}}</span>
          </a>
          <!-- Kinesis-specific fields -->
          @if (isKinesisTarget()) {
            <a class="panel-block">
              <span class="label">AWS Endpoint</span>
              <span class="value">{{Model.AWSEndpoint}}</span>
            </a>
            <a class="panel-block">
              <span class="label">Stream Name</span>
              <span class="value">{{Model.StreamName}}</span>
            </a>
            <a class="panel-block">
              <span class="label">Partition Key</span>
              <span class="value">{{Model.PartitionKey}}</span>
            </a>
          }
          <!-- SFTP-specific fields -->
          @if (isSFTPTarget()) {
            <a class="panel-block">
              <span class="label">SFTP Host</span>
              <span class="value">{{Model.SFTPHost}}</span>
            </a>
            <a class="panel-block">
              <span class="label">SFTP Username</span>
              <span class="value">{{Model.SFTPUsername}}</span>
            </a>
            <a class="panel-block">
              <span class="label">SFTP Key</span>
              <span class="value">
                @if (Model.SFTPKey) {
                  <span><i class="fas fa-key mr-1"></i>Key provided</span>
                }
                @if (!Model.SFTPKey) {
                  <span><i class="fas fa-exclamation-triangle mr-1 has-text-warning"></i>No key provided</span>
                }
              </span>
            </a>
            <a class="panel-block">
              <span class="label">Dispatch Schedule</span>
              <span class="value">{{Model.DispatchScheduleFriendlyString || 'Not configured'}}</span>
            </a>
          }
          <a class="panel-block">
            <span class="label">Parking Structures</span>
            @if (Model.Structures && Model.Structures.length > 0) {
              <span class="value">
                <div class="field is-grouped is-grouped-multiline">
                  @for (structure of Model.Structures; track structure) {
                    <div class="control">
                      <div class="tags has-addons">
                        <a class="tag">{{structure.Name}}</a>
                      </div>
                    </div>
                  }
                </div>
              </span>
            }
            @if (!Model.Structures || Model.Structures.length === 0) {
              <span class="value">
                No structures assigned
              </span>
            }
          </a>
        </article>
      </div>
    </div>
  </div>
}